






































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { Funcionalidades } from '@/config/funcionalidades';

import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import type {
  Cliente,
  DatosContrato,
  EstadoFirma,
  Ejecutivo,
  DetalleContrato as TypeDetalleContrato,
  Solucion,
  Modalidad,
  Plazo,
  Area,
  ArchivoContrato,
  Tipo,
} from '@/pantallas/SucursalVirtual/Contratos/types';
import Contrato from '@/pantallas/SucursalVirtual/Contratos/controllers/ContratoController';
import DetalleContrato from '@/pantallas/SucursalVirtual/Contratos/controllers/DetalleContratoController';
import ContratoGrillaDetalle from '@/pantallas/SucursalVirtual/Contratos/ContratoGrillaDetalle.vue';
import ContratoGrillaArchivo from '@/pantallas/SucursalVirtual/Contratos/ContratoGrillaArchivo.vue';


@Component({
  components: {
    ContratoGrillaDetalle,
    ContratoGrillaArchivo,
    'app-confirmacion': Confirmation,
    DatePicker,
  },
})
class ContratoModalEditar extends Vue {
  @Prop({ default: false }) esModoVerDetalle!: boolean;
  @Prop({ required: true }) contratoId!: TypeDetalleContrato['contratoId'];

  readonly accionesTotales: PermisoAccion[] = [
    {
      accionCodigo: 3,
      visible: false,
    },
    {
      accionCodigo: 4,
      visible: false,
    },
    {
      accionCodigo: 5,
      visible: false,
    },
  ];
  readonly funcionalidad = Funcionalidades.DetalleContrato;
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;
  get nombreArchivosSeleccionados() {
    return this.archivoContrato.archivos.map(a => a.nombreArchivo).join(', ');
  }

  recargarGrillaDella = false;
  recargarGrillaArchivo = false;
  dialog = true;
  mostrarModalConfirmacion = false;
  loading = true;
  archivoId = 0;
  fileSize = 0;
  estadoInicialArchivoContrato: ArchivoContrato = {
    contratoId: this.contratoId,
    archivos: [], // Inicializa como un array vacío
  };

  archivoContrato: ArchivoContrato = {
    ...this.estadoInicialArchivoContrato,
  };

  usuarioId = String(JSON.parse(localStorage.getItem('user')).id) || '';
  clienteDefecto = localStorage.getItem('clienteDefecto') || '';
  inhabilitarCampoPlazo = true;
  inhabilitarCampoModalidad = false;
  tipo: Tipo = {id: '',
  valor: ''} as Tipo;
  tipos: Tipo[] = [];
  ejecutivo: Ejecutivo = {} as Ejecutivo;
  ejecutivos: Ejecutivo[] = [];
  clientes: Cliente[] = [];
  cliente: Cliente = {} as Cliente;
  rut: Cliente = {} as Cliente;
  ruts: Cliente[] = [];
  precioArriendoVentaLabel = ''
  estadosFirma: EstadoFirma[] = [];
  soluciones: Solucion[] = [];
  modalidades: Modalidad[] = [];
  plazos: Plazo[] = [];
  areas: Area[] = [];
  email = String(JSON.parse(localStorage.getItem('user')).email) || '';
  datosContrato: DatosContrato = {} as DatosContrato;
  detalleContratoEstadoInicial: TypeDetalleContrato = {
    detalleId: undefined,
    contratoId: this.contratoId,
    solucionId: '',
    modalidadId: '1',
    plazoId: '0',
    precioServicio: '',
    precioArriendo: '',
    precioInstalacion: '',
    observacion: '',
  };
  detalleContrato: TypeDetalleContrato = {
    ...this.detalleContratoEstadoInicial
  };
  desactivarCampoEmail = !this.esModoVerDetalle;
  precioRegex = /^\d{1,8}(\.\d{1,2})?$/;
  emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  reglasContrato = {
    rut: ({ rut }: Cliente) => !!(rut || '').trim() || 'El rut es requerido',
    cliente: ({ cliente }: Cliente) => !!(cliente || '').trim() || 'El cliente es requerido',
    estadoFirma: (v: string) => !!(v || '').trim() || 'El estado de firma es requerido',
    ejecutivo: ({ nombre_completo }: Ejecutivo) => {
      return !!(nombre_completo || '').trim() || 'El ejecutivo es requerido'
    },
    ejecutivoEmail: (v: string) => {
      if (!v) return 'El email es requerido';
      return this.emailRegex.test(v) || 'El email no es válido';
    },
    area: (v: string) => !!(v || '').trim() || 'El área es requerida',
  };
  reglasDetalleContrato = {
    solucion: (v: string) => !!(v || '').trim() || 'La solución es requerida',
    modalidad: (v: string) => !!(v || '').trim() || 'La modalidad es requerida',
    plazo: (v: string) => {
      const val = (v || '').trim();
      if (!val || val === '0') return 'El plazo es requerido';
      return true;
    },
    precioServicio: (v: string) => {
      if (!v) return 'El precio de servicio es requerido';
      return this.precioRegex.test(v) || 'El precio de servicio no es válido';
    },
    precioArriendo: (v: string) => {
      if (!v) return 'El precio de arriendo es requerido';
      return this.precioRegex.test(v) || 'El precio de arriendo no es válido';
    },
    precioInstalacion: (v: string) => {
      if (!v) return 'El precio de instalación es requerido';
      return this.precioRegex.test(v) || 'El precio de instalación no es válido';
    },
  };
  reglasArchivo = {
    nombreArchivo: (v: string) => !!(v || '').trim() || 'El archivo es requerido',
  };
  timeOutId1: NodeJS.Timeout = null;
  timeOutId2: NodeJS.Timeout = null;
  esEditarDetalleContrato = false;

  handleChangeEjecutivo() {
    this.datosContrato.ejecutivoId = this.ejecutivo.id_ejecutivo;
    this.datosContrato.ejecutivoEmail = this.ejecutivo.email;
    this.desactivarCampoEmail = !!this.ejecutivo.email;
    const area = this.areas.find(({ area }) => ('' || area).toLowerCase() === (this.ejecutivo.area || '').toLowerCase());
    this.datosContrato.areaId = area ? area.id_area : '';
  }

  modalidadChange() {
    const { modalidad, id_modalidad } = this.modalidades.find(({ id_modalidad }) => id_modalidad === this.detalleContrato.modalidadId);
    this.precioArriendoVentaLabel = `Precio ${modalidad}`;
    if (this.inhabilitarCampoModalidad) return;
    this.inhabilitarCampoPlazo = id_modalidad === '1';
    if (this.inhabilitarCampoPlazo) {
      this.detalleContrato.plazoId = '0';
    }
  }

  buscarEjecutivo() {
    this.handleChangeEjecutivo();
  }

  buscarCliente() {
    if (typeof this.rut === 'object') {
      this.cliente = this.rut;
      this.datosContrato.rut = this.rut.rut;
      this.datosContrato.cliente = this.rut.cliente;
      let ej = this.ejecutivos.find(x => x.id_ejecutivo == this.rut.id_ejecutivo);
      if (ej !== undefined) {
        this.ejecutivo = ej;
      } else {
        this.ejecutivo = { id_ejecutivo: '', nombre_completo: '', email: '', area: '', };
      }
      this.datosContrato.ejecutivoEmail = this.rut.email_ejecutivo;
      this.buscarEjecutivo();
      return;
    }
    this.rut = {
      rut: this.rut,
      cliente: '',
      id_ejecutivo: '',
      email_ejecutivo: '',
    };
    this.datosContrato.rut = this.rut.rut;
    this.buscarEjecutivo();
  }

  buscarRut() {
    if (typeof this.cliente === 'object') {
      this.rut = this.cliente;
      this.datosContrato.rut = this.cliente.rut;
      this.datosContrato.cliente = this.cliente.cliente;
      return;
      let ej = this.ejecutivos.find(x => x.id_ejecutivo == this.cliente.id_ejecutivo);
      if (ej !== undefined) {
        this.ejecutivo = ej;
      } else {
        this.ejecutivo = { id_ejecutivo: '', nombre_completo: '', email: '', area: '', };
      }
      this.ejecutivo = this.ejecutivos.find(x => x.id_ejecutivo == this.cliente.id_ejecutivo);

      this.datosContrato.ejecutivoEmail = this.cliente.email_ejecutivo;
      this.buscarEjecutivo();
    }
    this.cliente = {
      rut: '',
      cliente: this.cliente,
      id_ejecutivo: '',
      email_ejecutivo: '',
    };
    this.datosContrato.cliente = this.cliente.cliente;
    this.buscarEjecutivo();
  }

  async mounted() {
    try {
      await this.obtenerContratoPorId();
      await this.obtenerDatosEjecutivo();
      await this.obtenerFiltrosDetalleContratos();
      await this.obtenerFiltrosContratos();
      await this.obtenerSoluciones();
      await this.obtenerTipos();
      this.recargarGrillaDellaFn();
    } finally {
      this.loading = false;
    }
  }

  recargarGrillaDellaFn() {
    this.timeOutId1 = setTimeout(() => {
      this.recargarGrillaDella = true;
      this.recargarGrillaArchivo = true;

      this.timeOutId2 = setTimeout(() => {
        this.recargarGrillaDella = false;
        this.recargarGrillaArchivo = false;
        this.clearTimeOuts();
      }, 1500);
    }, 1500);
  }

  clearTimeOuts() {
    if (this.timeOutId1) clearTimeout(this.timeOutId1);
    if (this.timeOutId2) clearTimeout(this.timeOutId2);
  }

  async obtenerContratoPorId() {
    this.loadingService.showLoading();
    try {
      const { contrato } = await Contrato.obtenerContratoPorId(this.contratoId);
      this.cliente = {
        rut: contrato.rut,
        cliente: contrato.cliente,
        id_ejecutivo: '',
        email_ejecutivo: '',
      }
      this.rut = {
        rut: contrato.rut,
        cliente: contrato.cliente,
        id_ejecutivo: '',
        email_ejecutivo: '',
      }
      this.datosContrato = contrato;
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async obtenerDatosEjecutivo() {
    this.loadingService.showLoading();
    try {
      const ejecutivoEmail = this.datosContrato.ejecutivoEmail || this.email;
      const { id_ejecutivo, nombre_completo, email, area } = await Contrato.obtenerEjecutivoPorId(ejecutivoEmail);
      this.ejecutivo = {
        id_ejecutivo,
        nombre_completo,
        email,
        area,
      };
      this.desactivarCampoEmail = !!email;
      this.datosContrato.ejecutivoEmail = email;
      this.datosContrato.ejecutivoId = id_ejecutivo;
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  archivoEscogido(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input.files.length) return;

    const files = Array.from(input.files);

    // Validar la cantidad de archivos según el tipo seleccionado
    if (this.tipo.id === '1' && files.length > 1) {
      this.$snotify.error('Para el tipo contrato, solo se permite subir un archivo');
      return;
    }

    this.archivoContrato.archivos = []; // Reinicia el array de archivos

    files.forEach(file => {
      if (file.size > 10 * 1024 * 1024) {
        this.$snotify.error(`El archivo ${file.name} es demasiado pesado. Solo se permiten archivos de hasta 10 MB.`);
        return;
      }
      if (file.type !== 'application/pdf') {
        this.$snotify.error(`El archivo ${file.name} debe ser de tipo PDF`);
        return;
      }

      const fr = new FileReader();
      fr.onload = () => {
        this.archivoContrato.archivos.push({
          archivoId: undefined,
          nombreArchivo: file.name,
          urlPdf: fr.result as string,
        });
      };
      fr.readAsDataURL(file);
    });

    this.archivoId += 1;
  }

  resetearValidacionesDetalleComercial() {
    (this.$refs.formularioDetalleContratoRef as any).resetValidation();
  }

  resetearValidacionesArchivo() {
    (this.$refs.agregarArchivoRef as any).resetValidation();
  }

  async obtenerFiltrosDetalleContratos() {
    this.loadingService.showLoading();
    try {
      const { actualModalidadPlazo, modalidades, plazos, areas } = await DetalleContrato.obtenerFiltrosDetalleContrato([], this.contratoId);
      if ('id_plazo' in actualModalidadPlazo && 'id_modalidad' in actualModalidadPlazo) {
        //this.detalleContrato.plazoId = actualModalidadPlazo.id_plazo;
        //this.detalleContrato.modalidadId = actualModalidadPlazo.id_modalidad;
        //this.inhabilitarCampoModalidad = true;
      }
      this.modalidades = modalidades;
      const { modalidad } = this.modalidades.find(({ id_modalidad }) => id_modalidad === this.detalleContrato.modalidadId);
      this.precioArriendoVentaLabel = `Precio ${modalidad}`;
      this.plazos = plazos;
      this.areas = areas;
    } catch (error) {
      this.$snotify.error((error as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async obtenerFiltrosContratos() {
    this.loadingService.showLoading();
    try {
      const { ejecutivos, clientes, estadosFirma } = await Contrato.obtenerFiltrosContratos();
      this.ejecutivos = ejecutivos;
      this.clientes = clientes;
      this.ruts = clientes;
      this.estadosFirma = estadosFirma;
    } catch (error) {
      this.$snotify.error((error as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async obtenerSoluciones() {
    this.loadingService.showLoading();
    try {
      const soluciones = await DetalleContrato.obtenerSoluciones();
      this.soluciones = soluciones;
    } catch (error) {
      this.$snotify.error((error as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async obtenerTipos() {
    this.loadingService.showLoading();
    try {
      const soluciones = await DetalleContrato.obtenerTipos();
      this.tipos = soluciones;
    } catch (error) {
      this.$snotify.error((error as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  handleCerrarModal() {
    if (this.esModoVerDetalle) {
      this.cerrarModal();
      return;
    }
    this.mostrarModalConfirmacion = true;
  }

  mostrarConfirmacion(aceptar: boolean) {
    aceptar && this.cerrarModal();
    this.mostrarModalConfirmacion = false;
  }

  cerrarModal() {
    this.$emit('cerrar', !this.esModoVerDetalle);
  }

  async validarReglasDatosIdentificacion() {
    const camposValidos = await (this.$refs.formularioDatosIdentificacionRef as any).validate();
    if (!camposValidos) {
      this.$snotify.error('Complete los datos requeridos');
      return;
    }
    this.editarContrato();
  }

  async validarReglasDetalleContrato() {
    this.detalleContrato.contratoId = this.datosContrato.contratoId;
    const camposValidos = await (this.$refs.formularioDetalleContratoRef as any).validate();
    if (!camposValidos) return;
    if (this.esEditarDetalleContrato) {
      this.editarDetalleContrato();
      return;
    }
    this.crearDetalleContrato();
  }

  handleSoloNumeros(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      event.preventDefault();
    }
  }

  async handleCrearArchivo() {
    const camposValidos = (this.$refs.agregarArchivoRef as any).validate();
    if (!camposValidos) return;

    if (!this.archivoContrato.archivos.length) {
      this.$snotify.error('Seleccione al menos un archivo');
      return;
    }

    // Validar si el tipo seleccionado permite la cantidad de archivos seleccionados
    if (this.tipo.id === '1' && this.archivoContrato.archivos.length > 1) {
      this.$snotify.error('Para este tipo, solo se permite subir un archivo');
      return;
    }

    this.crearArchivo();
  }

  validarNumeroDecimal(llave: 'precioServicio' | 'precioArriendo' | 'precioInstalacion') {
    // Paso 1: Normalizar el número
    let numero = this.detalleContrato[llave].replace(/,/g, '.');

    // Paso 2: Validar y formatear
    if (numero.includes('.')) {
      // Si el número contiene un punto, verificar la longitud antes y después del punto
      const [num, decimal] = numero.split('.');
      const parteEntera = num.length > 8 ? num.slice(0, 8) : num;
      const parteDecimal = decimal.slice(0, 2);
      numero = `${parteEntera}.${parteDecimal}`;
      if (decimal.length === 1) {
        numero += '0';
      }
    } else {
      if (numero.length > 10) {
        // Si el número tiene más de 10 dígitos, cortar los últimos dos dígitos
        numero = numero.slice(0, 10);
      }
      // Si el número no contiene un punto
      if (numero.length === 10) {
        // Si tiene 10 dígitos, insertar un punto antes de los últimos dos dígitos
        numero = `${numero.slice(0, 8)}.${numero.slice(8)}`;
      } else if (numero.length === 9) {
        // Si tiene 9 dígitos, agregar un '0' al final y luego insertar un punto
        numero = `${numero}0`;
        numero = `${numero.slice(0, 8)}.${numero.slice(8)}`;
      } else {
        // Si tiene 8 o menos dígitos, agregar '.00' al final
        numero += '.00';
      }
    }

    // Paso 3: Actualizar el valor
    this.detalleContrato[llave] = numero;
  }

  async editarContrato() {
    this.loadingService.showLoading();
    try {
      const { mensajeExito } = await Contrato.editarContrato(this.datosContrato, this.usuarioId, this.clienteDefecto);
      this.$snotify.success(mensajeExito);
      this.cerrarModal()
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async crearDetalleContrato() {
    this.loadingService.showLoading();
    try {
      const { mensajeExito } = await DetalleContrato.crearDetalleContrato(this.detalleContrato, this.usuarioId, this.clienteDefecto);
      this.$snotify.success(mensajeExito);
      const actualModalidadId = this.detalleContrato.modalidadId;
      const actualPlazoId = this.detalleContrato.plazoId;
      this.detalleContrato = {
        ...this.detalleContratoEstadoInicial,
        contratoId: this.datosContrato.contratoId,
        plazoId: '',
      };
      //this.inhabilitarCampoModalidad = true;
      this.inhabilitarCampoPlazo = true;
      this.resetearValidacionesDetalleComercial();
      this.recargarGrillaDella = true;
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      const timeOutId = setTimeout(() => {
        this.loadingService.hideLoading();
        this.recargarGrillaDella = false;
        clearTimeout(timeOutId);
      }, 1000);
    }
  }

  async editarDetalleContrato() {
    this.loadingService.showLoading();
    try {
      const { mensajeExito } = await DetalleContrato.editarDetalleContrato(this.detalleContrato, this.usuarioId, this.clienteDefecto);
      this.$snotify.success(mensajeExito);
      const actualModalidadId = this.detalleContrato.modalidadId;
      const actualPlazoId = this.detalleContrato.plazoId;
      this.detalleContrato = {
        ...this.detalleContratoEstadoInicial,
        contratoId: this.datosContrato.contratoId,
        modalidadId: actualModalidadId,
        plazoId: actualPlazoId,
      };
      this.modalidadChange();
      this.resetearValidacionesDetalleComercial();
      this.recargarGrillaDella = true;
      this.esEditarDetalleContrato = false;
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      const timeOutId = setTimeout(() => {
        this.loadingService.hideLoading();
        this.recargarGrillaDella = false;
        clearTimeout(timeOutId);
      }, 1000);
    }
  }

  async crearArchivo() {
    this.loadingService.showLoading();
    try {
      for (const archivo of this.archivoContrato.archivos) {
        const params = {
          contratoId: this.archivoContrato.contratoId,
          archivos: archivo, // Asegúrate de que archivo esté definido dentro de este bucle
          usuarioId: this.usuarioId,
          clienteDefecto: this.clienteDefecto,
          tipo: this.tipo.id // Asumiendo que tipo.id es un string
        };
        await DetalleContrato.crearArchivo(
          params.archivos,
          params.contratoId,
          params.usuarioId,
          params.clienteDefecto,
          params.tipo
        );
      }
      this.$snotify.success('Archivos guardados con éxito');
      (this.$refs.agregarArchivoRef as any).reset();
      this.recargarGrillaArchivo = true;
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      const timeOutId = setTimeout(() => {
        this.loadingService.hideLoading();
        this.recargarGrillaArchivo = false;
        clearTimeout(timeOutId);
      }, 1000);
    }
  }

  editarDetalleContratoData(data: TypeDetalleContrato) {
    this.detalleContrato = { ...data };
    this.esEditarDetalleContrato = true;
    this.inhabilitarCampoPlazo = false;
    this.inhabilitarCampoModalidad = false;
    this.$forceUpdate();
  }


}

export default ContratoModalEditar;
